import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { segmentKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useSegment = (segmentId) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('segments/detail/'), {
            ...additional,
            params: { segment_id: segmentId }
        }),
        queryKey: segmentKeys.detail(segmentId),
        enabled: segmentId > 0
    });
};
export default useSegment;
